import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { Package, PackageHost } from '../../Container';
import { inAssistantCommands } from './AssistantCommands';
import { AssistantMechanics } from './AssistantMechanics';
import { AssistantToolRegistry, inAssistantTools } from './AssistantToolRegistry';
import { inCoreAssistantTools } from './tools/core/InCoreAssistantTools';
import { developerReflect, groupIntoZones, GroupObjectsToolSupport } from './tools/grouping/GroupObjectsToolSupport';
import { AddStickiesToolSupport } from './tools/insert/AddStickiesToolSupport';
import { AddZonesToolSupport } from './tools/insert/AddZonesToolSupport';
import { DraftJiraIssueToolSupport } from './tools/jira/DraftJiraIssueToolSupport';
import { GetJiraProjectIdToolSupport } from './tools/jira/GetJiraProjectIdToolSupport';
import { ImportJiraIssuesToolSupport } from './tools/jira/ImportJiraIssuesToolSupport';

export class AssistantPackage implements Package {

    public install = (host: PackageHost) => host
        .register(AssistantMechanics, 'singleton', 'startable')
        .register(AssistantToolRegistry, 'singleton')
        .plug(inAssistantCommands())
        .plug(inCoreAssistantTools())
        .plug(inAssistantTools(GetJiraProjectIdToolSupport, DraftJiraIssueToolSupport, ImportJiraIssuesToolSupport))
        .plug(inAssistantTools(AddStickiesToolSupport, AddZonesToolSupport))
        .plug(inAssistantTools(GroupObjectsToolSupport))
        .plug(inCommands(groupIntoZones))
        .plug(inCommands(developerReflect))
        ;
}
